import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom'; // Use NavLink for active styles
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import logo from '../../assets/images/logo.png';
import './PublicHeader.css';
// import ThemeToggleButton from '../common/ThemeToggleButton'; 

const PublicHeader = ({ onEnquiryClick }) => {
  const [expanded, setExpanded] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Effect to handle scroll detection
  useEffect(() => {
    const handleScroll = () => {
      // Set scrolled state to true if user scrolls past 50px, otherwise false
      setIsScrolled(window.scrollY > 50);
    };

    // Add event listener on mount
    window.addEventListener('scroll', handleScroll);

    // Clean up event listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []); // Empty array ensures this effect runs only once

  const handleNavCollapse = () => setExpanded(false);
  const handleEnquiryAndClose = () => {
    onEnquiryClick();
    handleNavCollapse();
  };

  // Determine if navbar should be solid (white background)
  // It should be solid if scrolled OR if we are on the home page (as per user request)
  // Actually, user said "instead of transparent navbar i want solid white navbar on home page"
  // This implies Home Page should ALWAYS be solid.
  // For other pages, we keep the scroll behavior (transparent at top, solid when scrolled).
  const isHomePage = location.pathname === '/';
  const shouldBeSolid = isScrolled || isHomePage;

  return (
    // Add 'public-navbar' and the conditional 'navbar-scrolled' class
    <Navbar
      variant="dark"
      expand="lg"
      fixed="top" // Changed from sticky to fixed for better transparency effect
      className={`public-navbar ${shouldBeSolid ? 'navbar-scrolled' : ''}`}
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={handleNavCollapse} className="d-flex align-items-center">
          <img
            src={logo}
            height="50"
            className="d-inline-block align-top logo-img"
            alt="Sun Squad Solar Logo"
          />
          <span className="ms-2 fw-bold text-white brand-text">Sun Squad Solar</span>
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="ms-auto" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={NavLink} to="/" onClick={handleNavCollapse}>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/about" onClick={handleNavCollapse}>About Us</Nav.Link>
            <Nav.Link as={NavLink} to="/partner" onClick={handleNavCollapse} className="text-warning fw-bold">Become a Partner</Nav.Link>
            <Nav.Link as={NavLink} to="/locations" onClick={handleNavCollapse}>Our Project Location</Nav.Link>
            <Nav.Link as={NavLink} to="/gallery" onClick={handleNavCollapse}>Gallery</Nav.Link>
            <Nav.Link as={NavLink} to="/announcements" onClick={handleNavCollapse}>Announcement</Nav.Link>
            <Nav.Link as={NavLink} to="/contact" onClick={handleNavCollapse}>Contact Us</Nav.Link>

            {/* Desktop Buttons */}
            <Button variant="outline-primary" onClick={onEnquiryClick} className="d-none d-lg-inline-block mx-2">
              GET AN ENQUIRY
            </Button>
            <Button as={Link} to="/login" variant="dark" className="d-none d-lg-inline-block">
              LOGIN
            </Button>

             
            
            {/* Mobile Buttons (Inside the collapsed menu) */}
            <div className="d-lg-none mt-3">
                <Button variant="outline-primary" onClick={handleEnquiryAndClose} className="w-100 mb-2">
                  GET AN ENQUIRY
                </Button>
                <Button as={Link} to="/login" variant="dark" className="w-100" onClick={handleNavCollapse}>
                  LOGIN
                </Button>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default PublicHeader;